import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Error.css";

/**
 * Shared application error / not-found shell.
 * Default (`/error` route): application error copy.
 * `variant="notFound"`: branded page-not-found (PublicBrowseGate unknown slugs).
 */
class ErrorComponent extends Component {
  render() {
    const isNotFound = this.props.variant === "notFound";
    return (
      <div
        className={
          "error-bg" + (isNotFound ? " error-bg--not-found" : "")
        }
        role={isNotFound ? "status" : undefined}
      >
        <div className="row width-100">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 error-sec text-center">
            <div>
              <img
                src="assets/img/error.png"
                className="error-img"
                alt=""
              />
              <h4 className="error-text">
                {isNotFound
                  ? "We couldn’t find that page."
                  : "An error Occurred in the Application And Your Page could not be Served"}
              </h4>
              {isNotFound ? (
                <p className="error-subtext">
                  The page you requested isn’t available. Head home to keep
                  browsing.
                </p>
              ) : null}
              <Link to="/home" className="btn btn-danger mb-5">
                {isNotFound ? "Go to Home" : "go back"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorComponent;
